import { api } from '@/apis';
import { log } from '@/utils';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useScenes(groupCodes = []) {
  const queryKey = ['locations', 'scenes', groupCodes];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: ({ signal }) => {
      const json = [
        { $match: { type: 'SCENE' } },
        {
          $graphLookup: {
            from: 'groups',
            startWith: '$groupCodes',
            connectFromField: 'parentCodes',
            connectToField: 'code',
            as: 'groupAncestorCodes',
            depthField: 'depth',
          },
        },
        groupCodes.length > 0 && {
          $match: { 'groupAncestorCodes.code': { $in: groupCodes } },
        },
        {
          $lookup: {
            from: 'people',
            localField: 'code',
            foreignField: 'currentLocations.code',
            as: 'currentAttendees',
            pipeline: [
              {
                $project: {
                  _id: false,
                  forenames: true,
                  surname: true,
                  collarNumber: true,
                },
              },
            ],
          },
        },
        {
          $project: {
            _id: false,
            code: true,
            name: true,
            startTime: true,
            endTime: true,
            boundary: true,
            currentAttendees: true,
            attributes: {
              incidentCode: true,
              occurrenceNumber: true,
              requiredAttendance: true,
            },
            groupAncestorCodes: {
              $map: {
                input: '$groupAncestorCodes',
                as: 'group',
                in: '$$group.code',
              },
            },
            groups: {
              $map: {
                input: {
                  $filter: {
                    input: '$groupAncestorCodes',
                    cond: { $eq: ['$$group.depth', 0] },
                    as: 'group',
                  },
                },
                as: 'group',
                in: '$$group.name',
              },
            },
          },
        },
        { $sort: { name: 1 } },
      ].filter(Boolean);

      log('Read', 'Scenes');

      return api.post('pipeline/locations', { json, signal }).json();
    },
    placeholderData: [],
    staleTime: 30 * 60 * 1000,
  });

  return {
    query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
